import { IBadgesContext } from './interfaces';

export const getBadgesInitialData = async function (): Promise<IBadgesContext> {
  return {
    badges: [],
  };
};
